import { createSelector } from "@reduxjs/toolkit";
/**
 * @returns The status of the request that fetches the markups ielements
 */
export const markupsIElementsFetchingStatusSelector = createSelector(state => state.sdbIElements, sdbIElements => {
  return sdbIElements.markupsIElementsFetchingStatus;
});

/**
 * @returns True if the markups have been fetched from the backend
 */
export const hasFetchedMarkupsIElementsSelector = createSelector(markupsIElementsFetchingStatusSelector, fetchingStatus => {
  return fetchingStatus === "succeeded";
});

/**
 * @returns True if the markups are being fetched or are yet to be fetched from the backend
 */
export const isFetchingMarkupsIElementsSelector = createSelector(markupsIElementsFetchingStatusSelector, fetchingStatus => {
  return fetchingStatus === "uninitialized" || fetchingStatus === "pending";
});